import * as React from 'react';

const useLocalStorage = (storageKey, fallbackState) => {
    const[value, setValue] = React.useState(() => {
        try {
            const item = localStorage.getItem(storageKey);
            return item ? JSON.parse(item) : fallbackState;
        } catch (error) {
            console.error("Parsing error in useLocalStorage:", error);
            return fallbackState;
        }
        
    });

    React.useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(value));
    },[value, storageKey]);

    return [value, setValue];
};

export default useLocalStorage;
